import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MaterialModule } from '../../../core/models/material.module';
import { CommonModule } from '@angular/common';
import { LoaderService } from './loader.service';

@Component({
  selector: 'app-loader',
  imports: [MaterialModule,CommonModule],
  template: `
  <div *ngIf="isLoading | async" class="loading-overlay">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
`,
  styleUrl: './loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent {
  isLoading: any; 

  constructor(private loaderService: LoaderService) {
    this.isLoading = this.loaderService.loading$; 
  }
  

}
